function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0H24V24H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.8,4.125H4.2a.9965.9965,0,0,0-1,1v2.75a.9965.9965,0,0,0,1,1h.05v10.25a.749.749,0,0,0,.75.75H19a.75554.75554,0,0,0,.75-.75V8.875h.05a1.00291,1.00291,0,0,0,1-1V5.125A1.00291,1.00291,0,0,0,19.8,4.125Zm-1.05,14.75H5.25v-10h13.5Zm1.05-11H4.2V5.125H19.8Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.32527,15.89476,8.14854,13.718l-.74124.736,2.918,2.918,6.264-6.264-.736-.736Z"
});

var SvgIInstockOutline = function SvgIInstockOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIInstockOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_instock_outline.d9d5cbe0.svg";
export { ForwardRef as ReactComponent };